export const PICKER_RANGE = {
  CUSTOM: 5,
  TODAY: 0,
  LAST_30_DAYS: 3,
  CUSTOM_INDEX: 1,
};
